import {
  FormProps,
  InputDescription,
  InputName,
} from "@components-common/forms";
import { application } from "../../../_runtime/bootstrap";
import { useFormikContext } from "formik";
import { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Col } from "taltech-styleguide";
import { ParameterTypeRandom } from "./ParamaterTypeRandom";
import { useNotifications } from "@hooks";
import { useUserContext } from "../../../_runtime/iam/session.context";
import { roleMapper } from "../../../_runtime/iam/session.provider";

/**
 * Functional Component: BuildingParameterFormContent
 *
 * This component renders the content of the building parameter form, including input fields for the name, type, and description.
 *
 * Returns:
 * @returns {JSX.Element} A JSX element containing the form inputs.
 */
export const BuildingParameterFormContent: FC = () => (
  <Col xs="12" md="7">
    <InputName  elementClass="required" />
    <ParameterTypeRandom />
    <InputDescription elementClass="mt-2" />
  </Col>
);

/**
 * Functional Component: BuildingParameterForm
 *
 * This component manages the state and behavior of the building parameter form, handling form submission for creating and updating parameters.
 *
 * Props:
 * @param {FormProps<any>} props - The properties passed to the form component.
 *
 * Returns:
 * @returns {JSX.Element} A JSX element containing the building parameter form content.
 */
export const BuildingParameterForm: FC<FormProps<any>> = ({ ...props }) => {
  const nav = useNavigate();
  const formik = useFormikContext();
  const notifications = useNotifications();
  const { userId, userRole } = useUserContext();

  useEffect(() => {
    if (formik.isSubmitting) {
      if (formik.isValid) {
        let values: any = formik.values;
        if (values.type === "TEXT") {
          values = { ...values, creationType: "CONSTANT" };
        }

        if (props.id === "form_create") {
          values = {
            ...values,
            sourceId: userId,
            sourceType: userRole === roleMapper.Student ? "USER" : "SYSTEM",
          };
          application
            .getHttpClient()
            .post("/buildingms/categories/parameters", values)
            .then(() => nav(-1))
            .catch((error: any) => {
              notifications.error({ title: error.response.data.detail });
              formik.setSubmitting(false);
            });
        } else {
          application
            .getHttpClient()
            .put(`/buildingms/categories/parameters/${values.id}`, values)
            .then(() => nav(-1))
            .catch((error: any) => {
              notifications.error({ title: error.response.data.detail });
              formik.setSubmitting(false);
            });
        }
      }
    }
  }, [formik.isSubmitting]);

  return <BuildingParameterFormContent />;
};
